import * as views from "../views";
// import { i18nFormat } from "@/i18n.js";
// import RouterView from "@/core/components/RouteContainer.vue";

export default [
  {
    path: "500",
    name: "Error500",
    component: views.Error500
  },
  {
    path: "404",
    name: "Error404",
    component: views.Error404
  },
  {
    path: "maintain",
    name: "MaintainPage",
    component: views.Maintain
  },
  {
    path: "domain",
    name: "DomainError",
    component: views.Domain
  },
  {
    path: "shared/l/:id",
    name: "LibraryShare",
    component: views.LibraryShare
  },
  {
    path: "shared/error/:type",
    name: "ShareError",
    component: views.Expired
  },
  {
    path: "error/:type",
    name: "GlobalError",
    component: views.Expired
  },
  {
    path: "coupons/:id?",
    name: "Coupon",
    component: views.Coupon
  },
];
